module["exports"] = ["#####", "### ##", "###-##"];